// ------------- import external dependencies -------------
import styled from "styled-components";
import { IoMdArrowBack } from "react-icons/io";
// ----------- import internal dependencies -----------

export const FormWrapper = styled.div`
  margin-top: 2.5rem;
  /* max-width: 780px;
  margin-left: auto;
  margin-right: auto; */

  & > h2 {
    font-size: 1rem;
    color: var(--primaryPurpleMain);
    text-align: center;
  }
`;
export const MainInputContainer = styled.div`
  display: flex;
  flex-direction: column;
`;
export const IconHeadingContainer = styled.div`
  display: grid;
  margin: 10px 0;
  grid-template-columns: 0.6fr 4fr;
  @media screen and (min-width: 768px) {
    grid-template-columns: 0.1fr 1fr;
  }
  align-items: center;
`;
export const BackArrowIon = styled(IoMdArrowBack)`
  font-size: 1.5rem;
  color: var(--primaryPurpleMain);
  cursor: pointer;
`;
export const Heading = styled.h2`
  color: #3d0052;
  text-align: center;
  font-size: 1.1rem;
  @media screen and (min-width: 768px) {
    font-size: 1.5rem;
  }
`;
